import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@chatterbug/aaron'

import Filler from './Filler'

const ProgressBarVertical = ({
  completeFraction,
  backgroundColor = 'gray88',
  barColor = 'yellow65',
  ...props
}) => {
  // TODO: check flexShrink={0} for responsive
  return (
    <Flex
      {...props}
      width="5px"
      minWidth="5px"
      // TODO: fix height (should it be a set px or can it be 100%? Also 100% hides it for some reason)
      height={47}
      backgroundColor={backgroundColor}
      borderRadius="1x"
    >
      <Filler
        // To safeguard against user studying more than the goal prescribes and the completeFraction being > 100%
        completeFraction={completeFraction <= 100 ? completeFraction : 100}
        barColor={barColor}
      />
    </Flex>
  )
}

ProgressBarVertical.propTypes = {
  completeFraction: PropTypes.number,
  backgroundColor: PropTypes.string,
  barColor: PropTypes.string,
  barCompletedColor: PropTypes.string,
}

export default ProgressBarVertical
